import Sidebar from "../../../components/sidebar/Sidebar";
import Header from "../../../components/headerbar/Header";
// import "./product.scss";
import { useParams, useNavigate } from "react-router-dom";
import {config} from '../../../config'
import _ from "lodash";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import axios from "axios";

const BannerEdit = () => {
  const accesstoken = JSON.parse(localStorage.getItem("user"));
  const [sliders, setSliders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [productStyles, setproductStyles] = useState(null);

  const [weightrangeData, setWeightRangeData] = useState([]);
  const navigate = useNavigate();

  const [title, setTitle] = useState("");

  const [content, setContent] = useState("");

  const [image, setImage] = useState("");

  const [imagepreview, setImagepreview] = useState("");
  const [imagede, setImagede] = useState("");
  const [editimg, setImageedit] = useState("");
  const [subCategory_id, setSubCategory_id] = useState("");
  const [category_id, setCategory] = useState("");
  const [productstyle, setProductStyle] = useState("");
  const [mainCategoryParam, setMainCategoryParam] = useState("");
  const [mainSubCategoryParam, setMainSubCategoryParam] = useState("");
  const [weightRange, setWeightRange] = useState("");
  const [updateid, setUpdateid] = useState("");
  const [error, setError] = useState(false);
  const params = useParams();
  const [editValues, setEditValues] = useState(null);

  const getBanner = async () => {
    let bannerresult = await fetch(config.apiurl + "/sliders/getslider");
    bannerresult = await bannerresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}));
    setSliders(bannerresult.data.results);
  };
  const getCategory = async () => {
    let catresult = await fetch(config.apiurl + "/category/getcategory");
    catresult = await catresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}));
    setCategories(catresult?.data?.results);
  };

  const getSubCategory = async () => {
    if (category_id) {
      let subactresult = await fetch(
        config.apiurl + `/subcategory/${category_id}`,
        {
          method: "get",
          headers: {
            Authorization: "bearer " + accesstoken.data.access_token,
          },
        }
      );
      subactresult = await subactresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}));;
      console.log("data: " + JSON.stringify(subactresult?.data));
      setSubCategories(subactresult?.data);
    }
  };
  

  const getproductStyles = async () => {
    if(subCategory_id) {
      let productStyleslist = await fetch(
        config.apiurl + `/prostyle/bySubCatgory/sub/${subCategory_id}`,
        {
          method: "get",
          headers: {
            Authorization: "bearer " + accesstoken.data.access_token,
          },
        }
      ).catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}));
      productStyleslist = await productStyleslist.json();
      setproductStyles(productStyleslist?.data?.results);
    }
  };

  

  const getWeightRange = async () => {
    let weightrangelist = await fetch(config.apiurl + "/weightrange/");
    weightrangelist = await weightrangelist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}));
    const wwightRangeWithCheckedState = weightrangelist?.data?.results?.map(
      (data) => ({ ...data, checked: false, price: 0 })
    );
    setWeightRangeData(wwightRangeWithCheckedState);
  };

  const getProductedit = async () => {
    let proeditdetails = await fetch(
      config.apiurl + "/sliders/" + params.editid,
      {
        method: "get",
        headers: {
          Authorization: "bearer " + accesstoken.data.access_token,
        },
      }
    );
    proeditdetails = await proeditdetails.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}));
    setEditValues(proeditdetails?.data?.[0]);
    setImage(proeditdetails?.data[0]?.image);
    setTitle(proeditdetails?.data?.[0]?.title);
    setContent(proeditdetails?.data[0]?.content);
    setImageedit(proeditdetails?.data[0]?.image);
    setCategory(proeditdetails.data?.[0]?.category_id);
    setMainCategoryParam(proeditdetails.data[0]?.category_id);
    // setSubCategory_id(proeditdetails.data.subCategory_id?._id);
    // setMainSubCategoryParam(proeditdetails?.data?.subCategory_id?._id);
    setProductStyle(proeditdetails?.data[0]?.productstyle);
    setWeightRange(proeditdetails?.data?.[0]?.weightRange);

    if (params) {
      setImagepreview(config.fileurl + proeditdetails.data[0].image);
    }
  };

  const handlecategory = async (event) => {
    setCategory(event.target.value);
    setMainCategoryParam(event?.target?.value);
    setSubCategory_id("");
  };
  const handleSubCategory = async (event) => {
    setSubCategory_id(event.target.value);
    setMainSubCategoryParam(event.target.value);
    setProductStyle("");
  };

  const handleproductStyles = async (event) => {
    setProductStyle(event.target.value);
  };

  const handleWeightRange = async (event) => {
    setWeightRange(event?.target?.value);
  };

  // Set values for edit
  // useEffect(() => {
  //   const subCategory = subCategories?.find(
  //     (data) => data?._id === editValues?.subCategory_id
  //   );
  //   subCategory && setSubCategory_id(subCategory?._id);
  // }, [subCategories, editValues]);

  const handleImageupload = async (event) => {
    const fileup = event.target.files[0];
    Transformfile(fileup);
  };

  const Transformfile = (file) => {
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const fileSizeMB = file.size / (1024 * 1024); // Convert to MB
        const maxSizeMB = 1; // Maximum allowed size in MB

        if (fileSizeMB > maxSizeMB) {
          toast(`File size exceeds the limit. Please select an image less than ${maxSizeMB} MB.`, { type: "info" });
          return;
        }

        setImage(file.name);
        setImagepreview(reader.result);
        setImagede(file);
      };
    } else {
      setImage("");
      setImagepreview("");
      setImagede("");
    }
  };

  const submitProductDetails = async (res) => {
    const editupdateurl = config.apiurl + "/sliders/" + params.editid;
    const configdata = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + accesstoken.data.access_token,
      },
    };

    const ondataSuccess = (response) => {
      toast("Banner updated successfully");
      setTimeout(() => {
        navigate("/banner");
      }, 2000);
    };
    const ondataFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"})
    const editdata = {
      title: title,
      content: content,
      image: res,
      category_id: category_id,
      subCategory_id: subCategory_id,
      productstyle: productstyle,
      weightRange: weightRange,
    };
    axios
      .put(editupdateurl, editdata, configdata)
      .then(ondataSuccess, ondataFailure);
  };

  const handleProsubmit = async () => {
    if (
      !image ||
      !title?.trim() ||
      !category_id?.trim() ||
      !content?.trim() ||
      !subCategory_id?.trim() ||
      !productstyle?.trim() || 
      !weightRange?.trim()
    ) {
      setError(true);
      return false;
    }
    /*Image Upload process here */
    if (imagede) {
      const imageupurl = config.apiurl + "/upload/upload-single";
      const configimg = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: "bearer " + accesstoken.data.access_token,
        },
      };
      const formData = new FormData();
      formData.append("file", imagede);

      const onSuccess = (response) => {
        submitProductDetails(response.data.data.filename);
      };
      const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"})
      axios.post(imageupurl, formData, configimg).then(onSuccess, onFailure);
    } else {
      submitProductDetails(editimg);
    }
  };

  useEffect(() => {
    getBanner();
    getCategory();
    getWeightRange();
    getProductedit();
  }, []);

  useEffect(() => {
    getSubCategory();
  }, [categories, category_id]);
  useEffect(() => {
    getproductStyles();
  }, [subCategories, subCategory_id]);

  useEffect(() => {
    if (Array.isArray(subCategories)) {
      const subCategory = subCategories.find(
        (data) => data?._id === editValues?.subCategory_id
      );
      subCategory && setSubCategory_id(subCategory?._id);
    }
  }, [subCategories, editValues]);

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Edit Banner</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Title
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={title}
                          onChange={(e) => {
                            setTitle(e.target.value);
                          }}
                        />
                        {error && !title?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the title
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Image
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(event) => handleImageupload(event)}
                        />
                        {error && !imagepreview && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the image
                          </span>
                        )}
                      </div>
                    </div>
                    {imagepreview ? (
                      <div className="col-md-6">
                        {<img src={imagepreview} width="150" height="150" />}
                      </div>
                    ) : null}
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Content
                        </label>
                        <textarea
                          className="form-control"
                          rows="5"
                          value={content}
                          onChange={(e) => {
                            setContent(e.target.value);
                          }}
                        ></textarea>
                        {error && !content?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the content
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label
                              data-required="true"
                              htmlFor="example-text-input"
                              className="form-control-label"
                              required
                            >
                              Category
                            </label>
                            <select
                              required
                              className="form-control"
                              value={category_id}
                              onChange={(event) => {
                                handlecategory(event);
                              }}
                            >
                              <option value={""}> Choose </option>
                              {categories.length &&
                                categories.map((item, index) => (
                                  <option value={item._id}>{item.name}</option>
                                ))}
                            </select>
                            {error && !category_id?.trim() && (
                              <span className="text-danger text-gradient text-xs text-secondary">
                                Choose the category name
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label
                              data-required="true"
                              htmlFor="example-text-input"
                              className="form-control-label"
                              required
                            >
                              Product
                            </label>
                            <select
                              required
                              className="form-control"
                              value={subCategory_id}
                              onChange={(event) => handleSubCategory(event)}
                            >
                              <option value={""}> Choose </option>
                              {subCategories &&
                                subCategories.length &&
                                subCategories.map((item, index) => (
                                  <option value={item._id}>{item.name}</option>
                                ))}
                            </select>
                            {error && !subCategory_id?.trim() && (
                              <span className="text-danger text-gradient text-xs text-secondary">
                                Choose the product name
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label
                              data-required="true"
                              htmlFor="example-text-input"
                              className="form-control-label"
                            >
                              Sub Product
                            </label>
                            <select
                              className="form-control"
                              value={productstyle}
                              onChange={(event) => handleproductStyles(event)}
                            >
                              <option value={""}> Choose </option>
                              {productStyles &&
                                productStyles.length &&
                                productStyles.map((item, index) => (
                                  <option key={item._id} value={item?._id}>
                                    {item.name}
                                  </option>
                                ))}
                            </select>
                            {error && !productstyle?.trim() && (
                              <span className="text-danger text-gradient text-xs text-secondary">
                                Choose the sub product name
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label
                              data-required="true"
                              htmlFor="example-text-input"
                              className="form-control-label"
                              required
                            >
                              Weight Range
                            </label>
                            <select
                              required
                              className="form-control"
                              value={weightRange}
                              onChange={(event) => {
                                handleWeightRange(event);
                              }}
                            >
                              <option value={""}> Choose </option>
                              {weightrangeData.length &&
                                weightrangeData.map((item, index) => (
                                  <option value={item._id}>{item.range}</option>
                                ))}
                            </select>
                            {error && !weightRange?.trim() && (
                              <span className="text-danger text-gradient text-xs text-secondary">
                                Choose the weight range
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="text-end">
                      <button
                        type="button"
                        onClick={handleProsubmit}
                        className="btn btn-primary btn-sm ms-auto mt-5"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  );
};

export default BannerEdit;
